import afterNextPaint from "./afterNextPaint"

// Resolves once the page's first content has been painted (the browser's
// first-contentful-paint entry), or after the next painted frame plus 100 ms
// in browsers without paint timing. Resolves after at most 1 s either way,
// e.g. in a background tab, which doesn't paint.
export default function afterFirstPaint() {
  return new Promise((resolve) => {
    const done = () => {
      clearTimeout(timeout)
      resolve()
    }
    const timeout = setTimeout(done, 1000)
    const painted = () =>
      performance.getEntriesByName("first-contentful-paint").length > 0
    if (
      typeof performance === "undefined" ||
      typeof PerformanceObserver === "undefined" ||
      !PerformanceObserver.supportedEntryTypes?.includes("paint")
    ) {
      afterNextPaint().then(() => setTimeout(done, 100))
      return
    }
    if (painted()) {
      done()
      return
    }
    const observer = new PerformanceObserver(() => {
      if (painted()) {
        observer.disconnect()
        done()
      }
    })
    observer.observe({ type: "paint", buffered: true })
  })
}
